import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=38bc6699&scoped=true&"
var script = {}
import style0 from "./Overview.vue?vue&type=style&index=0&id=38bc6699&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc6699",
  null
  
)

export default component.exports